import { Component, type ReactNode } from 'react'
import { btn } from './ui'

/** Catches the editor failing to load (a deploy replaced its chunk under an open tab) so the rest
 *  of the page stays up and offers a refresh instead of going blank. */
export class EditorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false }
  static getDerivedStateFromError() { return { failed: true } }
  render() {
    if (!this.state.failed) return this.props.children
    return (
      <div role="alert" className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-radar-red/40 bg-radar-red/10 px-4 py-3 font-ui text-[14px] font-semibold text-radar-red">
        The editor needs a page refresh.
        <button type="button" className={btn} onClick={() => window.location.reload()}>Refresh</button>
      </div>
    )
  }
}
